import { apiRequest } from './authService';

/**
 * Get all customers
 * @returns {Promise<{success: boolean, data?: array, message?: string}>}
 */
export async function listCustomers() {
  try {
    const response = await apiRequest('customers', {
      method: 'POST'
    });

    if (response.success && response.data) {
      return {
        success: true,
        data: response.data,
        message: response.response
      };
    } else {
      return {
        success: false,
        data: [],
        message: response.response || 'Failed to fetch customers'
      };
    }
  } catch (error) {
    console.error('List customers error:', error);
    return {
      success: false,
      data: [],
      message: 'Network error. Please try again.'
    };
  }
}

/**
 * Search customers by query
 * @param {string} query Search query
 * @returns {Promise<{success: boolean, data?: array, message?: string}>}
 */
export async function searchCustomers(query) {
  try {
    const response = await apiRequest('customers/search', {
      method: 'POST',
      body: JSON.stringify({ query })
    });

    if (response.success && response.data) {
      return {
        success: true,
        data: response.data,
        message: response.response
      };
    } else {
      return {
        success: false,
        data: [],
        message: response.response || 'Search failed'
      };
    }
  } catch (error) {
    console.error('Search customers error:', error);
    return {
      success: false,
      data: [],
      message: 'Network error. Please try again.'
    };
  }
}

/**
 * Get a single customer by ID
 * @param {string|number} customerId Customer ID
 * @returns {Promise<{success: boolean, data?: object, message?: string}>}
 */
export async function getCustomer(customerId) {
  try {
    const response = await apiRequest('customers/get', {
      method: 'POST',
      body: JSON.stringify({ id: customerId })
    });

    if (response.success && response.data) {
      return {
        success: true,
        data: response.data,
        message: response.response
      };
    } else {
      return {
        success: false,
        message: response.response || 'Customer not found'
      };
    }
  } catch (error) {
    console.error('Get customer error:', error);
    return {
      success: false,
      message: 'Network error. Please try again.'
    };
  }
}

/**
 * Add a new customer
 * @param {object} customerData Customer data {name, info, phone, email}
 * @returns {Promise<{success: boolean, data?: object, message?: string}>}
 */
export async function addCustomer(customerData) {
  try {
    const response = await apiRequest('customers/add', {
      method: 'POST',
      body: JSON.stringify(customerData)
    });

    if (response.success && response.data) {
      return {
        success: true,
        data: response.data,
        message: response.response
      };
    } else {
      return {
        success: false,
        message: response.response || 'Failed to add customer'
      };
    }
  } catch (error) {
    console.error('Add customer error:', error);
    return {
      success: false,
      message: 'Network error. Please try again.'
    };
  }
}

/**
 * Update an existing customer
 * @param {string|number} customerId Customer ID
 * @param {object} customerData Customer data {name, info, phone, email}
 * @returns {Promise<{success: boolean, data?: object, message?: string}>}
 */
export async function updateCustomer(customerId, customerData) {
  try {
    const response = await apiRequest('customers/update', {
      method: 'POST',
      body: JSON.stringify({
        id: customerId,
        ...customerData
      })
    });

    if (response.success && response.data) {
      return {
        success: true,
        data: response.data,
        message: response.response
      };
    } else {
      return {
        success: false,
        message: response.response || 'Failed to update customer'
      };
    }
  } catch (error) {
    console.error('Update customer error:', error);
    return {
      success: false,
      message: 'Network error. Please try again.'
    };
  }
}

/**
 * Delete a customer
 * @param {string|number} customerId Customer ID
 * @returns {Promise<{success: boolean, message?: string}>}
 */
export async function deleteCustomer(customerId) {
  try {
    const response = await apiRequest('customers/delete', {
      method: 'POST',
      body: JSON.stringify({ id: customerId })
    });

    if (response.success) {
      return {
        success: true,
        message: response.response
      };
    } else {
      return {
        success: false,
        message: response.response || 'Failed to delete customer'
      };
    }
  } catch (error) {
    console.error('Delete customer error:', error);
    return {
      success: false,
      message: 'Network error. Please try again.'
    };
  }
}
